import { PropertyChanged } from '../utils/ObjectUtils';
export function updateAppConfigState(appConfigProp, appConfigState, setAppConfigState) {
    if (appConfigProp.main.platform !== "PEAKS" && PropertyChanged(appConfigProp.main, appConfigState.main)) {
        setAppConfigState(Object.assign({}, appConfigState));
    }
}
